import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import DetailsPanel from './DetailsPanel';
import TabsPanel from './TabsPanel';
import ButtonPanel from './ButtonPanel';

import { isEmpty } from 'lodash';

import { Splitter } from '@progress/kendo-react-layout';

import * as AttributeManagementActions from '../../../actions/attributeManagementActions';

import * as classes from './PanelContainer.module.css';

const PanelContainer = ({
    activeNavCompany,
    customAttributes,
    fetchEntities,
    ...props
}) => {
    const [selectedAttribute, setSelectedAttribute] = useState({});
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [items, setItems] = useState([]);
    const [entities, setEntities] = useState([]);
    const [value, setValue] = useState(0);
    const [clientAttributes, setClientAttributes] = useState([]);

    useEffect(() => {
        const init = async () => {
            const entity = await fetchEntities();
            
            setEntities(entity);
        };
        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        if (!isEmpty(customAttributes)) {
            if (!isEmpty(customAttributes['Client'])) {
                setClientAttributes(customAttributes['Client']);
            }
        }
    }, [customAttributes]);

    const [verticalPanes, setVerticalPanels] = useState([
        {
            collapsible: false
        },
        {
            size:        '5rem',
            resizable:   false,
            collapsible: false
        }
    ]);

    const [horizontalPanes, setHorizontalPanes] = useState([
        {
            size:        '450px',
            collapsible: true,
            resizable:   false,
        },
        {
            collapsible: false,
            resizable:   false,
        },
    ]);

    const onHorizontalChange = event => {
        setHorizontalPanes(event.newState);
    };

    const onVerticalChange = event => {
        setVerticalPanels(event.newState);
    };

    return (
        <Splitter
            style={{
                height: '80vh',
            }}
            orientation={'vertical'}
            panes={verticalPanes}
            onChange={onVerticalChange}
        >
            <Splitter
                panes={horizontalPanes}
                onChange={onHorizontalChange}
            >
                <div>
                    <DetailsPanel
                        entities={entities}
                        selectedAttribute={selectedAttribute}
                        selectedEntity={selectedEntity}
                        setSelectedAttribute={setSelectedAttribute}
                        setSelectedEntity={setSelectedEntity}
                        setValue={setValue}
                    />
                </div>
                <div>
                    <TabsPanel
                        clientAttributes={clientAttributes}
                        items={items}
                        setItems={setItems}
                        selectedAttribute={selectedAttribute}
                        selectedEntity={selectedEntity}
                        setValue={setValue}
                        value={value}
                    />
                </div>
            </Splitter>
            <div className={classes.ButtonPanel}>
                <ButtonPanel
                    items={items}
                    selectedEntity={selectedEntity}
                    selectedAttribute={selectedAttribute}
                    tabValue={value}
                />
            </div>
        </Splitter>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        customAttributes: state.attributeManagement.customAttributes,
    };
};

const mapDispatchToProps = {
    ...AttributeManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(PanelContainer);
